var map = {
	"./search-da-dk.png": 16481,
	"./search-de-de.png": 77144,
	"./search-en-gb.png": 14814,
	"./search-en-us.png": 63086,
	"./search-es-es.png": 949,
	"./search-es-mx.png": 45563,
	"./search-fr-fr.png": 69695,
	"./search-it-it.png": 62374,
	"./search-nb-no.png": 45954,
	"./search-nl-nl.png": 34154,
	"./search-pl-pl.png": 76095,
	"./search-pt-br.png": 51264,
	"./search-pt-pt.png": 87480,
	"./search-sv-se.png": 41957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5064;